<template>
  <div class="input-label flex flex-col">
    <label for="input" class="text-base w-1/2">{{ $ctx.locale == 'en' ? setting.enName: setting.arName }}</label>
    <div class="w-full md:w-1/2 lg:w-1/3">
      <FileManager v-model="val" @change="onChange"></FileManager>
    </div>
  </div>
</template>
<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {onMounted, ref} from "vue";
import FileManager from "@/components/file-manager/FileManager.vue";
import {useSettingsStore} from "@/stores/settingsStore";

const props = defineProps(['setting'])

const messages = {
  en: {},
  ar: {},
}
const {t} = useI18n({messages, useScope: 'global'})
const settingsStore = useSettingsStore();

const val = ref()
onMounted(() => {
  val.value = props.setting.value;
})

async function onChange(e: any) {
  try {
    await settingsStore.updateSetting(props.setting.key, props.setting.id, e.name)
  } catch (error) {
    console.log(error)
  }
}
</script>
